import { ElementProps } from '@/components/sections/builder/types';
import {
  HeroElementDataType,
  HeroTitleElementDataType,
} from '@/components/sections/builder/elements/body/hero/types';
import InputTab from '@/components/sections/builder/settings/input-tab';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { shallow } from 'zustand/shallow';
import { Type } from 'lucide-react';
import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';

const defaultData: HeroTitleElementDataType = {
  name: 'Title',
  label: 'Payments tool for software companies',
  headingSize: 'large',
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as HeroTitleElementDataType;
  const parentData = (element.parentData || {}) as HeroElementDataType;

  return (
    <>
      <h1
        className={clsx(
          'duration-50 theme_font_heading  w-full max-w-2xl text-left',
          `hero-title-padding hero-title-default-color`,
          data.headingSize === 'large' && 'text-4xl @sm:text-4xl md:text-5xl lg:text-6xl',
          data.headingSize === 'medium' && 'text-3xl @sm:text-3xl md:text-4xl lg:text-5xl',
          data.headingSize === 'small' && 'text-2xl @sm:text-2xl md:text-3xl lg:text-4xl'
        )}
        data-animation='true'
        dangerouslySetInnerHTML={{ __html: data.label }}
      />
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .hero-title-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }
          .hero-title-default-color {
            color: ${parentData.colorScheme?.text || 'text-gray-500'};
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as HeroTitleElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Text</div>
      <TextEditorMinimal
        value={data.label}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, { label: val });
        }}
        output='html'
        className='mb-2 w-full '
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
        placeholder='Button Title'
      />

      <div className='mb-4 mt-4 font-bold'>Heading Size</div>
      <InputTab
        defaultValue={data.headingSize}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            headingSize: v,
          })
        }
      />
      <PaddingSetting
        value={data.padding}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}

const HeroTitle = {
  type: 'hero_title',
  group: 'hero',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default HeroTitle;
